module.exports = __webpack_public_path__ + "img/wave-haikei.a43a135f.svg";